import EcgLoader from './container'

export default EcgLoader



// WEBPACK FOOTER //
// ./src/legacy/containers/EcgLoader/index.js